import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreateProviderSchema } from "@reactive-resume/dto";
import { useCreateProvider } from "@/client/services/payment-provider/create-provider";
import { useDialog } from "@/client/stores/dialog";
import { DialogMode } from "@/client/stores/dialog";
import { CreateProviderDto } from "@reactive-resume/dto";

export const CreatePaymentProviderDialog = () => {
  const { isOpen, close, mode } = useDialog("create-provider");
  const form = useForm<CreateProviderDto>({
    defaultValues: { name: "" },
  });
  const createProvider = useCreateProvider();

  const onSubmit = (data: CreateProviderDto) => {
    createProvider.mutate(data.name, {
      onSuccess: () => {
        form.reset();
        close();
      },
    });
  };

  if (mode !== "create") return null;

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nouveau Fournisseur de Paiement</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nom</FormLabel>
                  <FormControl>
                    <Input placeholder="Nom de l'aggregateur" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="submit">Créer</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
